"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2911],{

/***/ 16447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/Footer/index.js + 2 modules
var templates_Footer = __webpack_require__(49647);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Footer/Footer.js




var Footer = function Footer(_ref) {
  var staticProps = _ref["static"];
  return react.createElement(templates_Footer/* default */.Z, staticProps);
};
Footer.defaultProps = {
  "static": {}
};
 false ? 0 : void 0;
Footer.ssr = true;
Footer.displayName = 'Footer';
/* harmony default export */ var Footer_Footer = ((0,withLayoutProps/* default */.Z)(Footer));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Footer/index.js


/***/ }),

/***/ 87764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ FooterDesktop_FooterDesktop; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/templates/FooterDesktop/index.js + 7 modules
var templates_FooterDesktop = __webpack_require__(70385);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var esm = __webpack_require__(6422);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/FooterDesktop/FooterDesktop.styles.js

var _templateObject;


var Container = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(function () {
  return {
    bg: 'background.primary'
  };
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: center;\n  width: 100%;\n\n  #seloEbit > img {\n    height: 40px;\n    width: auto;\n    margin-right: ", "px;\n  }\n\n  ", "\n"])), (0,stereo_ui_styles_build_esm/* themeGet */.R)('space.3'), stereo_ui_styles_build_esm/* color */.$_);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/FooterDesktop/adaptStaticToStereoFooterProps.js

/* harmony default export */ var adaptStaticToStereoFooterProps = (function (_ref) {
  var staticProps = _ref.staticProps;
  var _staticProps$footerDa = staticProps.footerData,
    _staticProps$footerDa2 = _staticProps$footerDa === void 0 ? {} : _staticProps$footerDa,
    _staticProps$footerDa3 = _staticProps$footerDa2.certificatePartners,
    certificatePartners = _staticProps$footerDa3 === void 0 ? [] : _staticProps$footerDa3,
    _staticProps$footerDa4 = _staticProps$footerDa2.linksColumns,
    linksColumns = _staticProps$footerDa4 === void 0 ? [] : _staticProps$footerDa4,
    _staticProps$footerDa5 = _staticProps$footerDa2.contactSection,
    contactSection = _staticProps$footerDa5 === void 0 ? {} : _staticProps$footerDa5,
    _staticProps$footerDa6 = _staticProps$footerDa2.bottomInfo,
    bottomInfo = _staticProps$footerDa6 === void 0 ? {} : _staticProps$footerDa6,
    paymentMethods = _staticProps$footerDa2.paymentMethods,
    subscriptionForm = _staticProps$footerDa2.subscriptionForm;
  return {
    data: (0,esm_extends/* default */.Z)({
      bottomInfo: bottomInfo,
      certificatePartners: certificatePartners,
      contactSection: contactSection,
      linksColumns: linksColumns
    }, paymentMethods && {
      paymentMethods: paymentMethods
    }, subscriptionForm && {
      subscriptionForm: subscriptionForm
    })
  };
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/FooterDesktop/FooterDesktop.js









var FooterDesktop = function FooterDesktop(_ref) {
  var staticProps = _ref["static"];
  var footerProps = adaptStaticToStereoFooterProps({
    staticProps: staticProps
  });
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var handleMenuItemClick = function handleMenuItemClick(e, link, title) {
    publish('footer:menu:click', link, title);
    e.preventDefault();
    (0,esm/* routePush */.dY)({
      path: link == null ? void 0 : link.url,
      spa: true
    });
  };
  var handlePaymentMethodClick = function handlePaymentMethodClick(e, data) {
    publish('footer:payment:click', data);
  };
  var handleCertificateClick = function handleCertificateClick(e, link) {
    publish('footer:certificate:click', link);
  };
  return react.createElement(Container, null, react.createElement(templates_FooterDesktop/* default */.Z, (0,esm_extends/* default */.Z)({}, footerProps, {
    onMenuItemClick: handleMenuItemClick,
    onPaymentMethodClick: handlePaymentMethodClick,
    onCertificateClick: handleCertificateClick
  })));
};
 false ? 0 : void 0;
FooterDesktop.defaultProps = {
  "static": {}
};
FooterDesktop.ssr = true;
FooterDesktop.displayName = 'FooterDesktop';
/* harmony default export */ var FooterDesktop_FooterDesktop = ((0,withLayoutProps/* default */.Z)(FooterDesktop));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/FooterDesktop/index.js


/***/ }),

/***/ 15148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ FooterDesktopPMD_FooterDesktopPMD; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/FooterDesktopPMD/FooterDesktopPMD.styles.js

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;



var AuxiliaryInfo = styled_components_browser_esm/* default.div */.ZP.div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: ", "px 0;\n"])), (0,esm/* themeGet */.R)('space.2'));
var CertificatesPartnersList = styled_components_browser_esm/* default.ul */.ZP.ul(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n\n  a {\n    display: block;\n  }\n"])));
var Container = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(function () {
  return {
    bg: 'background.base'
  };
})(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin-top: 24px;\n  padding: 24px 20px;\n  width: 100%;\n\n  ", "\n"])), esm/* color */.$_);
var Content = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 1366px;\n"])));
var DevelopedByText = styled_components_browser_esm/* default.div */.ZP.div(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: ", "px;\n  text-align: right;\n"])), (0,esm/* themeGet */.R)('fontSizes.0'));
var Image = styled_components_browser_esm/* default.img */.ZP.img(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-height: ", ";\n  margin-right: ", "px;\n"])), function (props) {
  return props.maxHeight;
}, (0,esm/* themeGet */.R)('space.2'));
var InfoText = styled_components_browser_esm/* default.p.attrs */.ZP.p.attrs(function () {
  return {};
})(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n  font-size: ", "px;\n  margin-bottom: ", "px;\n  line-height: ", "px;\n"])), function (props) {
  return (0,esm/* getTextColor */.uu)('base')(props);
}, (0,esm/* themeGet */.R)('fontSizes.0'), (0,esm/* themeGet */.R)('space.2'), (0,esm/* themeGet */.R)('lineHeights.tall'));
var LinkItem = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).attrs(function () {
  return {
    color: 'text.base',
    fontSize: 0,
    underlineOnHover: true
  };
})(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 0 ", "px;\n"])), (0,esm/* themeGet */.R)('space.2'));
var LogoParceiro = styled_components_browser_esm/* default.div */.ZP.div(_templateObject9 || (_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  justify-content: center;\n\n  > img {\n    width: 208px;\n  }\n"])));
var NavigationLinks = styled_components_browser_esm/* default.ul */.ZP.ul(_templateObject10 || (_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: ", "px 0;\n  display: flex;\n  justify-content: center;\n"])), (0,esm/* themeGet */.R)('space.2'));
var PaymentMethodsList = styled_components_browser_esm/* default.ul */.ZP.ul(_templateObject11 || (_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n\n  img {\n    width: 52px;\n    height: 40px;\n  }\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/FooterDesktopPMD/FooterDesktopPMD.js




var FooterDesktopPMD = function FooterDesktopPMD(_ref) {
  var staticProps = _ref["static"];
  var footerData = staticProps.footerData;
  var auxiliaryInfo = footerData.auxiliaryInfo,
    logo = footerData.logo,
    navigationLinks = footerData.navigationLinks,
    paymentMethods = footerData.paymentMethods,
    certificatePartners = footerData.certificatePartners,
    bottomInfo = footerData.bottomInfo;
  return react.createElement(Container, null, react.createElement(Content, null, react.createElement(LogoParceiro, null, react.createElement(Image, {
    "data-testid": "logo-parceiro",
    src: logo.src,
    alt: logo.alt
  })), !!navigationLinks.links && react.createElement(NavigationLinks, null, navigationLinks.links.map(function (link) {
    return react.createElement("li", {
      key: link.label
    }, react.createElement(LinkItem, {
      href: link.url,
      title: link.label,
      target: "_blank",
      rel: "noreferrer"
    }, link.label));
  })), !!auxiliaryInfo.texts && react.createElement(AuxiliaryInfo, null, auxiliaryInfo.texts.map(function (text) {
    return react.createElement(InfoText, {
      key: text
    }, text);
  })), !!paymentMethods.list && react.createElement(AuxiliaryInfo, null, react.createElement(InfoText, null, paymentMethods.label), react.createElement(PaymentMethodsList, null, paymentMethods.list.map(function (item) {
    return react.createElement("li", {
      key: item.title
    }, react.createElement(Image, {
      src: item.img,
      alt: item.title
    }));
  }))), !!certificatePartners.certificates && react.createElement(AuxiliaryInfo, null, react.createElement(InfoText, null, certificatePartners.title.label), react.createElement(CertificatesPartnersList, null, certificatePartners.certificates.map(function (item) {
    return react.createElement("li", {
      key: item.content.alt
    }, react.createElement("a", {
      href: item.content.url,
      target: "_blank",
      rel: "noreferrer",
      title: item.content.alt
    }, react.createElement(Image, {
      src: item.content.img,
      alt: item.content.alt,
      maxHeight: item.content.maxHeight
    })));
  })), react.createElement(DevelopedByText, null, react.createElement("span", null, "desenvolvido por "), react.createElement("strong", null, "magazineluiza"), react.createElement("span", null, ".com"))), !!bottomInfo.texts && react.createElement(AuxiliaryInfo, null, bottomInfo.texts.map(function (text) {
    return react.createElement(InfoText, {
      key: text
    }, text);
  }))));
};
 false ? 0 : void 0;
FooterDesktopPMD.defaultProps = {
  "static": {}
};
FooterDesktopPMD.ssr = true;
FooterDesktopPMD.displayName = 'FooterDesktopPMD';
/* harmony default export */ var FooterDesktopPMD_FooterDesktopPMD = ((0,withLayoutProps/* default */.Z)(FooterDesktopPMD));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/FooterDesktopPMD/index.js


/***/ }),

/***/ 51921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ FooterService_FooterService; }
});

// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/FinancialServices/FinancialServicesDataFallback.js
var FinancialServicesDataFallback = __webpack_require__(16700);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/FooterService/FooterService.styles.js


var _templateObject, _templateObject2, _templateObject3;





var Container = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).attrs(function () {
  return {
    bg: 'background.whisper',
    px: 2,
    py: 2
  };
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)([""])));
var Paragraph = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    fontSize: 0,
    py: 1
  }, props);
})(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  color: ", ";\n  ", "\n  ", "\n"])), (0,esm/* getTextColor */.uu)('footer'), index_esm/* typography */.cp, esm/* color */.$_);
var Section = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).attrs(function () {
  return {
    py: 1
  };
})(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)([""])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/FooterService/FooterService.js




var FooterService = function FooterService(_ref) {
  var data = _ref.data;
  var _ref2 = (data == null ? void 0 : data.serviceContent) || FinancialServicesDataFallback/* FinancialServicesDataFallback */.n,
    footerContent = _ref2.footerContent;
  return react.createElement("footer", {
    "data-testid": "footer-service-container"
  }, react.createElement(Container, null, footerContent == null ? void 0 : footerContent.map(function (paragraph) {
    return react.createElement(Section, {
      key: paragraph.title,
      "data-testid": "footer-service-section"
    }, react.createElement(Paragraph, null, paragraph.title), react.createElement(Paragraph, null, paragraph.content));
  })));
};
 false ? 0 : void 0;
FooterService.defaultProps = {
  data: {
    serviceContent: {}
  }
};
/* harmony default export */ var FooterService_FooterService = (FooterService);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/FooterService/index.js


/***/ }),

/***/ 26444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Gatekeeper_Gatekeeper; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(76854);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Strip/index.js + 2 modules
var Strip = __webpack_require__(85737);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var esm = __webpack_require__(6422);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var stereo_ui_icons_build_esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dialog/index.js + 1 modules
var Dialog = __webpack_require__(66762);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Gatekeeper/Gatekeeper.styles.js

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;







var CloseGateKeeper = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs(function () {
  return {
    color: 'primary',
    fontSize: 0,
    fontWeight: 'medium',
    marginBottom: 2,
    marginTop: 3
  };
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)([""])));
var DialogStyled = (0,styled_components_browser_esm/* default */.ZP)(Dialog/* default */.Z)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-bottom: ", "px;\n  padding-left: ", "px;\n  padding-right: ", "px;\n  padding-top: ", "px;\n  width: 260px;\n  position: absolute;\n  top: 115px;\n"])), (0,stereo_ui_styles_build_esm/* themeGet */.R)('space.3'), (0,stereo_ui_styles_build_esm/* themeGet */.R)('space.3'), (0,stereo_ui_styles_build_esm/* themeGet */.R)('space.3'), (0,stereo_ui_styles_build_esm/* themeGet */.R)('space.3'));
var Divisor = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: ", ";\n  height: 0.5px;\n  width: 93px;\n"])), (0,stereo_ui_styles_build_esm/* themeGet */.R)('palette.text.scratched'));
var DivisorContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(function () {
  return {
    color: 'text.scratched',
    marginBottom: 3,
    marginTop: 4
  };
})(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n  height: 14px;\n"])));
var GatekeeperButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).attrs(function () {
  return {
    color: 'primary',
    marginBottom: 1,
    marginTop: 4
  };
})(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  pointer-events: ", ";\n  height: 38px;\n"])), function (props) {
  return props.pointerEvents;
});
var Header = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(function () {
  return {
    marginBottom: 4,
    marginTop: 2
  };
})(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex-direction: column;\n  width: 114px;\n"])));
var Logo = (0,styled_components_browser_esm/* default */.ZP)(stereo_ui_icons_build_esm/* LogoMagalu */.ZGh).attrs(function () {
  return {
    color: 'primary.base',
    height: 25,
    viewBox: '0 0 60 14',
    width: 114
  };
})(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  vertical-align: middle;\n"])));
var ModalContent = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n"])));
var Subtitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs(function () {
  return {
    color: 'scratched',
    fontSize: 1,
    fontWeight: 'regular',
    lineHeight: 'display',
    marginBottom: 1
  };
})(_templateObject9 || (_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var Title = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs(function () {
  return {
    color: 'dark',
    fontSize: 2,
    lineHeight: 'display'
  };
})(_templateObject10 || (_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-weight: ", ";\n"])), (0,stereo_ui_styles_build_esm/* themeGet */.R)('fontWeights.medium'));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Gatekeeper/Gatekeeper.js







var Gatekeeper = function Gatekeeper(_ref) {
  var structure = _ref.structure,
    config = _ref.config,
    staticProps = _ref["static"];
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var waitTime = staticProps.waitTime,
    waitPointerTime = staticProps.waitPointerTime,
    exhibitionLimit = staticProps.exhibitionLimit,
    textContent = staticProps.textContent,
    appUrl = staticProps.appUrl,
    appUrlDeepLink = staticProps.appUrlDeepLink;
  var title = textContent.title,
    subtitle = textContent.subtitle,
    divisor = textContent.divisor,
    mainButton = textContent.mainButton,
    closeGatekeeper = textContent.closeGatekeeper;
  var publicRuntimeConfig = config.publicRuntimeConfig;
  var cookieDomains = publicRuntimeConfig == null ? void 0 : publicRuntimeConfig.cookieDomain;
  var domain = cookieDomains ? cookieDomains[structure == null ? void 0 : structure.site] || (cookieDomains == null ? void 0 : cookieDomains["default"]) : null;
  var encodeAppURL = encodeURIComponent(appUrlDeepLink);
  var appLink = appUrl.concat(encodeAppURL);
  var GATEKEEPER_EXHIBITION = esm/* cookiesConstants.GATEKEEPER_EXHIBITION */.VD.GATEKEEPER_EXHIBITION;
  var gatekeeperExhibitionRule = (0,esm/* getCookie */.ej)(GATEKEEPER_EXHIBITION);
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = (0,react.useState)('none'),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    pointerEvents = _useState4[0],
    setPointerEvents = _useState4[1];
  var setGatekeeperCookies = function setGatekeeperCookies(value) {
    (0,esm/* setCookie */.d8)({
      domain: domain,
      name: GATEKEEPER_EXHIBITION,
      value: value
    });
  };
  var handleCloseGatekeeper = function handleCloseGatekeeper() {
    if (pointerEvents === 'all') {
      setOpen(false);
    }
  };
  var handleSendToApp = function handleSendToApp() {
    publish('gatekeeper:click');
    setGatekeeperCookies(exhibitionLimit);
    setOpen(false);
    (0,esm/* routePush */.dY)({
      path: appLink
    });
  };
  (0,react.useEffect)(function () {
    var waitTimerId;
    var pointerTimerId;
    var cookieValue = Number.isNaN(+gatekeeperExhibitionRule) ? 0 : +gatekeeperExhibitionRule;
    if (cookieValue < exhibitionLimit) {
      waitTimerId = setTimeout(function () {
        var isBodyOverflowVisible = document.body.style.overflow !== 'hidden';
        if (isBodyOverflowVisible) {
          setOpen(true);
          setGatekeeperCookies(cookieValue + 1);
        }
      }, waitTime);
      pointerTimerId = setTimeout(function () {
        setPointerEvents('all');
      }, waitTime + waitPointerTime);
    }
    return function () {
      clearTimeout(waitTimerId);
      clearTimeout(pointerTimerId);
    };
  }, []);
  return react.createElement(react.Fragment, null, open && react.createElement(DialogStyled, {
    "data-testid": "gatekeeper",
    fullScreen: true,
    position: "center",
    onClickOutside: handleCloseGatekeeper
  }, react.createElement(ModalContent, null, react.createElement(Header, null, react.createElement(Logo, {
    alt: "Logo Magalu"
  }), react.createElement(Strip/* default */.Z, {
    position: "relative",
    size: 1.6
  })), react.createElement(Title, null, title), react.createElement(Subtitle, null, subtitle), react.createElement(GatekeeperButton, {
    pointerEvents: pointerEvents,
    "data-testid": "gatekeeper-link",
    onClick: handleSendToApp,
    full: true
  }, mainButton), react.createElement(DivisorContainer, null, react.createElement(Divisor, null), divisor, react.createElement(Divisor, null)), react.createElement(CloseGateKeeper, {
    "data-testid": "close-gatekeeper",
    onClick: handleCloseGatekeeper
  }, closeGatekeeper))));
};
/* harmony default export */ var Gatekeeper_Gatekeeper = (Gatekeeper);
 false ? 0 : void 0;
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Gatekeeper/index.js


/***/ }),

/***/ 30241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7896);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59740);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _magalu_stereo_ui_atoms_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60861);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hocs_withLayoutProps__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89382);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6422);
/* harmony import */ var _magalu_mixer_publisher__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87333);


var _excluded = ["miniAppName", "eventButton", "sku", "buttonLabel", "href", "label"];






var GenericButton = function GenericButton(_ref) {
  var staticProps = _ref["static"];
  var _ref2 = staticProps || {},
    miniAppName = _ref2.miniAppName,
    eventButton = _ref2.eventButton,
    sku = _ref2.sku,
    buttonLabel = _ref2.buttonLabel,
    href = _ref2.href,
    label = _ref2.label,
    props = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_ref2, _excluded);
  var _usePublisher = (0,_magalu_mixer_publisher__WEBPACK_IMPORTED_MODULE_5__/* .usePublisher */ .Np)(),
    publish = _usePublisher.publish;
  var handleClickLinkInformation = function handleClickLinkInformation(e) {
    e.preventDefault();
    (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_4__/* .routePush */ .dY)({
      path: href,
      spa: true
    });
    publish(eventButton, {
      buttonLabel: buttonLabel,
      miniAppName: miniAppName,
      sku: sku
    });
  };
  return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_magalu_stereo_ui_atoms_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    "data-testid": "button-container",
    href: href,
    onClick: handleClickLinkInformation
  }, props), label);
};
GenericButton.defaultProps = {
  "static": {
    href: '',
    label: ''
  }
};
 false ? 0 : void 0;
GenericButton.ssr = true;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_hocs_withLayoutProps__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(GenericButton));

/***/ }),

/***/ 52516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _GenericButton__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _GenericButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30241);


/***/ })

}]);